import {SliderIconType} from '../instument_top_block/slider/SliderIconType';

export interface DrawInstrumentMenuData
{
    sliderIconType: SliderIconType;
    type:DrawInstrumentType;
    useSize?:boolean;
    useColor?:boolean;
}

export enum DrawInstrumentType
{
    POINTER = 'arrow',
    BRUSH = 'curved',
    ERASER = 'eraser',
    TEXTFIELD = 'text',
    TRASH = 'trash',
}
